import React, { useState } from 'react';
import { Accordion, Form } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import Alert from 'react-bootstrap/Alert';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';


function App() {
  const finalOutputRef = React.createRef();

  const [externalverb, setExternalVerb] = useState('');
  const [externalgoalstatement, setExternalGoalStatement] = useState('');
  const [externalmotivationstatement, setExternalMotivationStatement] = useState('');
  const [externalconflictstatement, setExternalConflictStatement] = useState('');

  const externalGoalOutput = `The Protagonist ${externalverb} ${externalgoalstatement}`;
  const externalMotivationOutput = `${externalGoalOutput} because ${externalmotivationstatement}`;
  const externalConflictOutput = `${externalMotivationOutput} but ${externalconflictstatement}.`;

  const [internalverb, setInternalVerb] = useState('');
  const [internalgoalstatement, setInternalGoalStatement] = useState('');
  const [internalmotivationstatement, setInternalMotivationStatement] = useState('');
  const [internalconflictstatement, setInternalConflictStatement] = useState('');

  const internalGoalOutput = `The Protagonist ${internalverb} ${internalgoalstatement}`;
  const internalMotivationOutput = `${internalGoalOutput} because ${internalmotivationstatement}`;
  const internalConflictOutput = `${internalMotivationOutput} but ${internalconflictstatement}.`;

 // Check if statements are filled in
 const isExternalGoalStatementFilled = externalgoalstatement.trim() !== '';
 const isExternalMotivationStatementFilled = externalmotivationstatement.trim() !== '';
 const isExternalConflictStatementFilled = externalconflictstatement.trim() !== '';

 const isInternalGoalStatementFilled = internalgoalstatement.trim() !== '';
 const isInternalMotivationStatementFilled = internalmotivationstatement.trim() !== '';
 const isInternalConflictStatementFilled = internalconflictstatement.trim() !== '';

  const copyToClipboard = () => {
    const finalOutputDiv = finalOutputRef.current;
    const range = document.createRange();
    range.selectNode(finalOutputDiv);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range);
    document.execCommand('copy');
    window.getSelection().removeRange(range);
  };


  return (
    <div className="App">
      <div className="AccordionContainer">
      <Accordion defaultActiveKey="1">
      <Accordion.Item eventKey="1">
        <Accordion.Header>Step 1: Introduction</Accordion.Header>
        <Accordion.Body>

  
              <p>Goal, motivation, and conflict. These are the ingredients of the dish the writer cooks to make an enticing book for the reader. Let's build all the goals, motivation, and conflict for your character.</p>
              <p>Use the sections below to guide you in creating Goal-Motivation-Conflict statements.</p>
              <ol>
                <li>You start with the goal, then the motivation for that goal and finally the conflict.</li>
                <li>Once you complete the statements, you can click the "Copy to Clipboard" button. Go to your favorite editor like MS Word, etc. and hit paste.</li>
                </ol>
               
 

        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="2">
        <Accordion.Header>Step 2: External Goal {isExternalGoalStatementFilled && <span className="CheckmarkIcon">&#10003;</span>}</Accordion.Header>
        <Accordion.Body>
        <p>What is the ultimate goal or reward that your character wants? What should they have done/accomplished by the end of the book?</p>
        <Form>
                <Form.Group>
                  <Form.Label>The Protagonist...</Form.Label>
                  <Form.Control className="form-select" as="select" value={externalverb} onChange={(e) => setExternalVerb(e.target.value)}>
                    <option value="must">must</option>
                    <option value="must not">must not</option>
                    <option value="wants to">wants to</option>

                    <option value="craves">craves</option>
                   <option value="needs to">needs to</option>
                   <option value="is destined to">is destined to</option>
                   <option value="is required to">is required to</option>
                   <option value="cannot">cannot</option> 
                   <option value="hates">hates</option>
                   <option value="has to">has to</option>

                  </Form.Control>
                </Form.Group>
                <Form.Group>
                  
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={externalgoalstatement}
                    onChange={(e) => setExternalGoalStatement(e.target.value)}
                  />
                  <br />
                  <p>The protagonist must <b>raise a large sum of money to save her house from foreclosure</b>.</p>
                </Form.Group>
              </Form>

        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="3">
        <Accordion.Header>Step 3: External Motivation {isExternalMotivationStatementFilled && <span className="CheckmarkIcon">&#10003;</span>}</Accordion.Header>
        <Accordion.Body>
          
        <p>Why is your character motivated to accomplish the goal above? What tangible thing drives them to the finish line? This part is important since you want to keep the reader reading with a focused motivation.</p>
              <p>{externalGoalOutput}</p>
              <p>...because</p>
              <Form.Group>
                
                <Form.Control
          as="textarea"
          rows={3}
          value={externalmotivationstatement}
          onChange={(e) => setExternalMotivationStatement(e.target.value)}
        />
        <br />
                <p>Example: The protagonist must raise a large sum of money because <b>the bank has foreclosed on her family's home.</b> </p>
                <p>The main character has an urgent goal to raise money or lose her house.</p>
              </Form.Group>


        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="4">
        <Accordion.Header>Step 4: External Conflict {isExternalConflictStatementFilled && <span className="CheckmarkIcon">&#10003;</span>}</Accordion.Header>
        <Accordion.Body>
         

        <p>Why can't your character reach their goal? (Or even why should they NOT reach it?) </p>
              <p>{externalMotivationOutput}</p>
              <p>...but</p>
              <Form.Group>
                
                <Form.Control
          as="textarea"
          rows={3}
          value={externalconflictstatement}
          onChange={(e) => setExternalConflictStatement(e.target.value)}
        />
        <br />
               <p>Example: The protagonist must raise a large sum of money since the bank has foreclosed on her family's home, but <b>she lost her job last month. </b> </p>
               <p>The main character has a big conflict to keep her from easily reaching her goal.</p>
              
              </Form.Group>


        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="5"> 
        <Accordion.Header>Step 5: External GMC Statement</Accordion.Header>
        <Accordion.Body>
        <div id="finalexternalstatement">
               <p> <b>{externalConflictOutput}</b></p>

                <Alert variant="success">
      <Alert.Heading>Keep up the good work!</Alert.Heading>
      <p>
      You've finished the external GMC! Time to move on to the internal. Is your external GMC something associated with the whole manuscript or just one scene? Keep up the good work!
      </p>
      
    </Alert>

                
              </div>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="6">
        <Accordion.Header>Step 6: Internal Goal {isInternalGoalStatementFilled && <span className="CheckmarkIcon">&#10003;</span>}</Accordion.Header>
        <Accordion.Body>
          
        <p>Internal goals relate to emotions and thoughts that emerge from within your character. What does their heart desire? By the end of the book what would make them happy or feel a sense of accomplishment?</p>
        <Form>
                <Form.Group>
                  <Form.Label>The Protagonist...</Form.Label>
                  
                  <Form.Select className="form-select" aria-label="Default select example" value={internalverb} onChange={(e) => setInternalVerb(e.target.value)}>
                    <option value="must">must</option>
                    <option value="must not">must not</option>
                    <option value="wants to">wants to</option>

                    <option value="craves">craves</option>
                   <option value="needs to">needs to</option>
                   <option value="is destined to">is destined to</option>
                   <option value="is required to">is required to</option>
                   <option value="cannot">cannot</option> 
                   <option value="hates">hates</option>
                   <option value="has to">has to</option>

                  </Form.Select>
                </Form.Group>
                <Form.Group>
                 
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={internalgoalstatement}
                    onChange={(e) => setInternalGoalStatement(e.target.value)}
                  />
                  <br />
                  <p>Example: The protagonist <b>needs to learn how to trust their alcoholic sister again.</b></p>
                </Form.Group>
              </Form>


        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="7">
        <Accordion.Header>Step 7: Internal Motivation {isInternalMotivationStatementFilled && <span className="CheckmarkIcon">&#10003;</span>}</Accordion.Header>
        <Accordion.Body>
        <Alert variant="info">
        <p>Why is your character motivated to accomplish the internal goal? What has happened that motivates them to accomplish the goal?</p>
    </Alert>
       
              <p>{internalGoalOutput}</p>
              <p>...because</p>
              <Form.Group>
                
                <Form.Control
          as="textarea"
          rows={3}
          value={internalmotivationstatement}
          onChange={(e) => setInternalMotivationStatement(e.target.value)}
        />
        <br />
                <p>Example: The protagonist needs to learn how to trust his alcoholic sister because <b>she has completed rehab again, secured a job, and she is trying to reconnect with him.</b></p>
              </Form.Group>

        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="8">
        <Accordion.Header>Step 8: Internal Conflict {isInternalConflictStatementFilled && <span className="CheckmarkIcon">&#10003;</span>}</Accordion.Header>
        <Accordion.Body>

        <Alert variant="info">
        <p>Why can't your character reach their goal? (Or even why should they NOT reach it?) What feelings are in the way? What might happen?</p>
    </Alert>
       
              <p>{internalMotivationOutput}</p>
              <p>...but</p>
              <Form.Group>
                
                <Form.Control
          as="textarea"
          rows={3}
          value={internalconflictstatement}
          onChange={(e) => setInternalConflictStatement(e.target.value)}
        />
        <br />
               <p>Example:The protagonist needs to learn how to trust their alcoholic sister because she has completed rehab and she is trying to reconnect with them, but <b>the protagonist is tired of saving her over and over again when she relapses.</b> This internal conflict should keep the protagonist from their goal.</p>
              
              </Form.Group>


        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="9">
        <Accordion.Header>Step 9: Internal GMC Statement</Accordion.Header>
        <Accordion.Body>
          
        <p><b>{internalConflictOutput}</b></p>
        <Alert variant="success">
      <Alert.Heading>Keep up the good work!</Alert.Heading>
      <p>
      You've finished the internal GMC! Is your internal GMC something associated with the whole manuscript or just one scene?
      </p>
      
    </Alert>


        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
   
    <br /><br />
<div id="finaloutput" ref={finalOutputRef}>
      <Table striped bordered hover>
      <thead>
        <tr>
         
          <th>&nbsp;</th>
          <th>External</th>
          <th>Internal</th>
        </tr>
      </thead>
      <tbody>
         
        <tr>
          <td>Goal</td><td>{externalgoalstatement}</td><td>{internalgoalstatement}</td>
        </tr>
         <tr>
         <td>Motivation</td><td>{externalmotivationstatement}</td><td>{internalmotivationstatement}</td>
       </tr>
       <tr>
         <td>Conflict</td><td>{externalconflictstatement}</td><td>{internalconflictstatement}</td>
       </tr>
       </tbody>
      </Table></div>
      <button onClick={copyToClipboard} className="CopyButton">
        Copy Final Goal Motivation Conflict Grid to Clipboard
      </button>
    </div>
    </div>
  );
}

export default App;